webpackJsonp([263791100135453],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TFP-logo-header-red.6937adeb.png";

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lettuce-grow-fishing-sustainable.f4ddfdb1.jpg";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lettuce-grow-urban-farming.372f14c0.png";

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'contactus' },
	    _react2.default.createElement(
	      'div',
	      { className: 'newsletter' },
	      _react2.default.createElement(
	        'div',
	        { className: 'contactus__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contactus__left' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'newsletter__title' },
	            'Contact Us'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Have a question or want to get involved?',
	            _react2.default.createElement('br', null),
	            'We\u2019d love to hear from you!'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contactus__right' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'mailto:info@thefarmproject.com',
	                target: '_blank'
	              },
	              _react2.default.createElement('i', { className: 'fas fa-envelope' }),
	              'info@thefarmproject.com'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://instagram.com/farmproject',
	                target: '_blank'
	              },
	              _react2.default.createElement('i', { className: 'fab fa-instagram' }),
	              '@farmproject'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.facebook.com/thefarmproject',
	                target: '_blank'
	              },
	              _react2.default.createElement('i', { className: 'fab fa-facebook' }),
	              'facebook.com/thefarmproject'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(106);
	
	var _lettuceGrowUrbanFarming = __webpack_require__(117);
	
	var _lettuceGrowUrbanFarming2 = _interopRequireDefault(_lettuceGrowUrbanFarming);
	
	var _lettuceGrowFishingSustainable = __webpack_require__(116);
	
	var _lettuceGrowFishingSustainable2 = _interopRequireDefault(_lettuceGrowFishingSustainable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FromTheBlog = function (_React$Component) {
	    _inherits(FromTheBlog, _React$Component);
	
	    function FromTheBlog(props) {
	        _classCallCheck(this, FromTheBlog);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    FromTheBlog.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'from-the-blog' },
	            _react2.default.createElement(
	                'figure',
	                { className: 'from-the-blog__title' },
	                'From The ',
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Blog'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'from-the-blog__content' },
	                this.props.data.edges.map(function (_ref, i) {
	                    var node = _ref.node;
	
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/blog/' + node.slug, className: 'from-the-blog__read-more' },
	                            _react2.default.createElement(
	                                'figure',
	                                {
	                                    className: 'from-the-blog__image',
	                                    style: node.heroImage && node.heroImage.file ? {
	                                        backgroundImage: 'url(' + node.heroImage.file.url + '?fm=jpg&q=80&w=800&h=800&fl=progressive&fit=thumb&f=face'
	                                    } : {}
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'from-the-blog__tag' },
	                                    node.category ? node.category.title : ''
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'from-the-blog__text' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'from-the-blog__headline' },
	                                node.title
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'from-the-blog__copy' },
	                                node.introductoryQuote ? node.introductoryQuote.introductoryQuote : ''
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: '/blog/' + node.slug, className: 'from-the-blog__read-more' },
	                                'Read More'
	                            )
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return FromTheBlog;
	}(_react2.default.Component);
	
	exports.default = FromTheBlog;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	  _inherits(Hero, _React$Component);
	
	  function Hero(props) {
	    _classCallCheck(this, Hero);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { locked: '' };
	    return _this;
	  }
	
	  Hero.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll.bind(this));
	  };
	
	  Hero.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll.bind(this));
	  };
	
	  Hero.prototype.handleScroll = function handleScroll(event) {
	    // if (event.srcElement.body.scrollTop > window.innerHeight + 100) {
	    //   this.setState({ locked: 'hero--scrolled' });
	    // } else {
	    //   this.setState({ locked: '' });
	    // }
	  };
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero' },
	      _react2.default.createElement(
	        'div',
	        { className: this.state.locked },
	        _react2.default.createElement('div', { className: 'hero__background' }),
	        _react2.default.createElement('div', { className: 'hero__slogan' }),
	        _react2.default.createElement('div', {
	          alt: this.props.title,
	          title: this.props.title,
	          className: 'hero__overlay'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__title' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__copy' },
	          'Founded by Zooey Deschanel and Jacob Pechenik,',
	          _react2.default.createElement('br', null),
	          'The Farm Project empowers initiatives that reconnect people with food.'
	        )
	      )
	    );
	  };
	
	  return Hero;
	}(_react2.default.Component);
	
	exports.default = Hero;
	;
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(108);
	
	var _TFPLogoHeaderRed = __webpack_require__(115);
	
	var _TFPLogoHeaderRed2 = _interopRequireDefault(_TFPLogoHeaderRed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        _ref$hasLowerPadding = _ref.hasLowerPadding,
	        hasLowerPadding = _ref$hasLowerPadding === undefined ? true : _ref$hasLowerPadding;
	    return _react2.default.createElement(
	        'div',
	        { className: 'main ' + (hasLowerPadding ? 'main__with-lower-padding' : '') },
	        _react2.default.createElement(
	            'div',
	            { className: 'main__content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__copy' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'main__content__headline' },
	                    data.mainHeading
	                ),
	                _react2.default.createElement('img', { className: 'main__logo', src: _TFPLogoHeaderRed2.default }),
	                _react2.default.createElement('div', {
	                    className: 'main__content__copy__inner',
	                    dangerouslySetInnerHTML: {
	                        __html: marked(data.mainText.mainText, {
	                            gfm: true,
	                            breaks: true
	                        })
	                    }
	                }),
	                !!data.callToActionText && !!data.callToActionUrl && _react2.default.createElement(
	                    'div',
	                    { className: 'collaborations__link' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: data.callToActionUrl, target: '_blank' },
	                        data.callToActionText,
	                        _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__image' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'main__content__image__expander' },
	                    data.imageLinkUrl && data.imageLinkUrl !== 'NONE' ? _react2.default.createElement(
	                        'a',
	                        { href: data.imageLinkUrl, target: '_blank' },
	                        _react2.default.createElement('img', { src: data.mainVideoUrl })
	                    ) : _react2.default.createElement('iframe', { src: data.mainVideoUrl, scrolling: 'no', frameBorder: '0', allowFullScreen: 'true' })
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helmetBuilder = __webpack_require__(19);
	
	var _helmetBuilder2 = _interopRequireDefault(_helmetBuilder);
	
	var _hero = __webpack_require__(74);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _main = __webpack_require__(75);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _aboutContact = __webpack_require__(163);
	
	var _aboutContact2 = _interopRequireDefault(_aboutContact);
	
	var _fromTheBlog = __webpack_require__(73);
	
	var _fromTheBlog2 = _interopRequireDefault(_fromTheBlog);
	
	__webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    { className: 'about' },
	    _react2.default.createElement(_helmetBuilder2.default, {
	      data: data.about.edges[0].node,
	      pathname: location.pathname
	    }),
	    _react2.default.createElement(_hero2.default, { title: 'About Us' }),
	    _react2.default.createElement(_main2.default, { data: data.about.edges[0].node }),
	    _react2.default.createElement(_aboutContact2.default, null),
	    _react2.default.createElement(_fromTheBlog2.default, { data: data.fromTheBlog })
	  );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-94b6597253014b0ab81d.js